<input #fileUploader uppDataid="image-file-input" type="file" accept="image/*" style="display:none" (change)="OnChange($event)">

<ng-template #imageConfigFormTemplate>
    <input #configUploader uppDataid="image-config-file-input" type="file" accept="image/*" style="display:none" (change)="OnConfigImageChange($event)">
    
    <upp-form [formGroup]="ConfigForm">
        <upp-form-section class="image-mode-selector" fill="clear">
            <upp-form-buttonbar>
                <upp-form-barbutton uppDataid="image-config-mode-avatar" color="primary" [active]="true" [disabled]="!CanAvatar" (click)="OnAvatar()">
                    <ion-label>
                        <ion-icon name="person-circle-outline"></ion-icon><br/>
                        <span class="small">{{ tr('@image_config_mode_avatar') }}</span>
                    </ion-label>
                </upp-form-barbutton>
                <upp-form-barbutton uppDataid="image-config-local-button" color="primary" [active]="true" (click)="OnConfigImageClick()">
                    <ion-label>
                        <ion-icon name="cloud-upload-outline"></ion-icon><br/>
                        <span class="small">{{ tr('@image_config_mode_upload') }}</span>
                    </ion-label>
                </upp-form-barbutton>
                <upp-form-barbutton uppDataid="image-config-internet-button" color="primary" [active]="true" [disabled]="!CanSearch" (click)="OnSearch()">
                    <ion-label>
                        <ion-icon name="globe-outline"></ion-icon><br/>
                        <span class="small">{{ tr('@image_config_mode_search') }}</span>
                    </ion-label>
                </upp-form-barbutton>
                <upp-form-barbutton uppDataid="image-config-crop-button" color="primary" [active]="true" [disabled]="!CanCrop" (click)="OnCropCurrent()">
                    <ion-label>
                        <ion-icon name="crop-outline"></ion-icon><br/>
                        <span class="small">{{ tr('@image_config_mode_crop') }}</span>
                    </ion-label>
                </upp-form-barbutton>
            </upp-form-buttonbar>
            <ion-button uppDataid="image-config-use-found-button"
                *ngIf="SearchReady"
                class="use-found-image-button"
                expand="block"
                fill="clear"
                color="primary"
                (click)="OnUseSearch()"
            >
                {{ tr('@image_config_use_found_image') }}
            </ion-button>
        </upp-form-section>

        <upp-form-section uppDataid="image-config-content-box" [title]="tr('@image_config_content')" fill="solid">
            <ion-item class="text-option" lines="none">
                <upp-input uppDataid="image-config-text-input"
                    formControlName="text"
                    [title]="tr('@image_config_text_value')"
                    [placeholder]="tr('@image_config_text_value')"
                ></upp-input>
            </ion-item>

            <upp-color
                [label]="tr('@image_config_bg_color')"
                [value]="ConfigForm.get('bgHex')?.value"
                [dataid]="'image-config-bg-color'"
                (Changed)="OnColorChanged('background', $event)"
            ></upp-color>
            <upp-color
                [label]="tr('@image_config_text_color')"
                [value]="ConfigForm.get('fgHex')?.value"
                [dataid]="'image-config-text-color'"
                (Changed)="OnColorChanged('foreground', $event)"
            ></upp-color>

            <ion-radio-group uppDataid="image-config-textmode-radiogroup" class="text-mode-options" formControlName="avatarMode">
                <ion-item lines="none">
                    <ion-label>{{ tr('@image_config_text_mode_initials') }}</ion-label>
                    <ion-radio slot="end" value="min"></ion-radio>
                </ion-item>
                <ion-item lines="none">
                    <ion-label>{{ tr('@image_config_text_mode_full') }}</ion-label>
                    <ion-radio slot="end" value="full"></ion-radio>
                </ion-item>
            </ion-radio-group>

            <ion-button uppDataid="image-config-delete-button"
                expand="block"
                fill="clear"
                color="danger"
                *ngIf="value !== null"
                (click)="OnDelete()"
            >
                {{ tr('@image_config_remove_image') }}
            </ion-button>
        </upp-form-section>
    </upp-form>
</ng-template>

<div class="image-preview">
    <div class="background" [ngClass]="{ 'visible': !IsVisible, 'noevents': readonly }"
        tabindex="0"
        (click)="mode === 'config' && ShowConfig ? (ShowConfig = false) : null"
        (keydown.enter)="mode === 'config' && ShowConfig ? (ShowConfig = false) : null"
        (keydown.space)="mode === 'config' && ShowConfig ? (ShowConfig = false) : null"
    >
        <ng-container *ngIf="_source && (_loaded || _online || IsCached)">
            <img *ngIf="_cors === true" #image alt="unpispas image" [hidden]="!IsVisible" (load)="OnLoaded()" [src]="_source" [attr.loading]="_loading" crossorigin="anonymous" />
            <img *ngIf="_cors !== true" #image alt="unpispas image" [hidden]="!IsVisible" (load)="OnLoaded()" [src]="_source" [attr.loading]="_loading" />
        </ng-container>
        <ng-container *ngIf="_source === null">
            <div class="nophoto"></div>
        </ng-container>
    </div>

    <div uppDataid="image-open-config-button" *ngIf="!readonly && !ShowConfig" class="image-label">
        <div class="actions">
            <ion-label tabindex="0" (click)="OnClick($event)" (keydown.enter)="OnClick($event)" (keydown.space)="OnClick($event)">
                <ion-icon [name]="mode === 'config' ? 'settings' : 'camera'"></ion-icon>
                <br/>{{tr('@title_modify_image')}}
            </ion-label>
        </div>
    </div>
</div>

<div *ngIf="mode === 'config'" class="image-config" [ngClass]="{ 'open': ShowConfig }">
    <div class="config-panel">
        <ng-container *ngTemplateOutlet="imageConfigFormTemplate"></ng-container>
    </div>
</div>

